import type { ConfirmFn } from '../seams';

// AP-0r — the confirm flow behind the inline "turn it off" long-press beside
// the reminder cue (EffortNudgeOptOut in EffortBandCue.tsx). Split out of
// FocusPanelEffort purely to keep that coordinator file under its line
// budget; it is still this cue's own logic, not a shared concern. A plain
// function, not a hook: it holds no state of its own — the preference is
// FocusPanelEffort's existing useEffortNudgeEnabled() call, and `setEnabled`
// is that SAME setter passed through, so the Settings switch and this
// control can never drift into two states.
//
// Long-press-then-confirm mirrors the codebase's own gesture for a
// permanent, hard-to-undo flip nobody should trigger by accident
// (useWorkoutDelete's onLongPressDelete) — a control that turns a preference
// off for good needs the same two-step friction a destructive delete does.

//
// ⛔ The confirm arrives through the SEAM, and is a parameter rather than an
// import: this file lives in packages/ui, where react-native's Alert is a
// no-op on react-native-web (RW-25). Before that the whole control was inert
// on the web — the long-press asked a question the browser never rendered.
type Translate = (key: string, opts?: Record<string, unknown>) => string;

export function confirmEffortNudgeOptOut(
  t: Translate,
  setEnabled: (v: boolean) => void,
  confirm: ConfirmFn,
): void {
  void confirm({
    title: t('mobile.logger.effortNudgeOptOutConfirmTitle', {
      defaultValue: 'Turn off this reminder?',
    }),
    body: t('mobile.logger.effortNudgeOptOutConfirmBody', {
      defaultValue: 'You can turn it back on anytime in Settings.',
    }),
    confirmLabel: t('mobile.logger.effortNudgeOptOutConfirmButton', {
      defaultValue: 'Turn off',
    }),
    cancelLabel: t('mobile.common.cancel', { defaultValue: 'Cancel' }),
  }).then((ok) => {
    if (ok) setEnabled(false);
  });
}
